import styles from './ActionItem.module.css'
import type {Icon} from '@primer/octicons-react'
import {clsx} from 'clsx'
import {Action, type ActionConfig} from './Action'

export interface ActionItemProps {
  /** Leading icon rendered before the title */
  leadingIcon?: Icon
  /** Primary label for the action item */
  title: string
  /** Optional secondary description or metadata line */
  description?: string
  /** Optional config for trailing link or button action */
  action?: ActionConfig
  /** Optional additional class name */
  className?: string
}

export function ActionItem({leadingIcon: LeadingIcon, title, description, action, className}: ActionItemProps) {
  return (
    <li className={clsx(styles.container, !description && styles.noDescription, className)}>
      {LeadingIcon && (
        <span className={styles.leadingIcon}>
          <LeadingIcon size={16} />
        </span>
      )}
      <div className={styles.content}>
        <span className={styles.title}>{title}</span>
        {description && <p className={styles.description}>{description}</p>}
      </div>
      {action && (
        <span className={styles.trailing}>
          <Action action={action} />
        </span>
      )}
    </li>
  )
}
